<mat-card>
  <mat-card-header>
    <mat-card-title>Import de rapports</mat-card-title>
  </mat-card-header>

  <div *ngIf="!loaded">Chargement ...</div>

  <div *ngIf="loaded">
    <div [ngSwitch]="selectionMode">
      <div *ngSwitchCase="'montlhy'">
        <p>Veuillez selectioner les mois que vous voulez importer</p>

        <mat-card-content>
          <mat-selection-list #monthsSelectionList (selectionChange)="onSelection()">
            <mat-list-option *ngFor="let date of monthsData" [value]="date.value" [disabled]="date.missingColums?.length > 0">
              {{ date.date | date : 'MMMM-YYYY' }}
              <span *ngIf="date.missingColums?.length > 0"> Erreur: Colonnes manquantes: {{ date.missingColums.join(',') }} </span>
            </mat-list-option>
          </mat-selection-list>
        </mat-card-content>
      </div>

      <div *ngSwitchCase="'yearly'">
        <p>Veuillez selectioner les années que vous voulez importer</p>

        <mat-card-content>
          <mat-selection-list #yearsSelectionList (selectionChange)="onSelection()">
            <mat-list-option *ngFor="let year of yearsData" [value]="year.value" [disabled]="year.missingColums?.length > 0">
              {{ year.value }}
              <span *ngIf="year.missingColums?.length > 0"> Erreur: Colonnes manquantes: {{ year.missingColums.join(',') }} </span>
            </mat-list-option>
          </mat-selection-list>
        </mat-card-content>
      </div>

      <mat-card-content *ngSwitchCase="'location'">
        <div *ngIf="hasErrors">
          <p>Erreur: Des colonnes sont manquantes :</p>

          <ul *ngFor="let col of rentReportsImportInfo.missingColumns">
            <li>{{ col }}</li>
          </ul>
        </div>

        <div *ngIf="!hasErrors">
          <p>Nous avons trouvé {{ rentReportsImportInfo.inFile.length }} rapport(s)</p>

          <p>La base de donnée contient actuellement {{ rentReportsImportInfo.inDb.length }} rapport(s)</p>

          <p>{{ rentReportsImportInfo.toCreate.length }} rapport(s) vont être créé(s)</p>

          <ul>
            <li *ngFor="let name of rentReportsImportInfo.toCreate">
              {{ name }}
            </li>
          </ul>

          <p>{{ rentReportsImportInfo.toUpdate.length }} rapport(s) vont être mis à jour</p>

          <ul>
            <li *ngFor="let name of rentReportsImportInfo.toUpdate">
              {{ name }}
            </li>
          </ul>
        </div>
      </mat-card-content>

      <mat-card-content *ngSwitchCase="'gallery'">
        <div *ngIf="hasErrors">
          <p>Erreur: Des colonnes sont manquantes :</p>

          <ul *ngFor="let col of galleriesImportInfo.missingColumns">
            <li>{{ col }}</li>
          </ul>
        </div>
        <div *ngIf="!hasErrors">
          <p>Nous avons trouvé {{ galleriesImportInfo.inFile.length }} galerie(s).</p>

          <p>La base de donnée contient actuellement {{ galleriesImportInfo.inDb.length }} galerie(s)</p>

          <p>{{ galleriesImportInfo.toCreate.length }} galerie(s) vont être créé(s)</p>

          <ul>
            <li *ngFor="let name of galleriesImportInfo.toCreate">
              {{ name }}
            </li>
          </ul>

          <p>{{ galleriesImportInfo.toUpdate.length }} rapport(s) vont être mis à jour</p>

          <ul>
            <li *ngFor="let name of galleriesImportInfo.toUpdate">
              {{ name }}
            </li>
          </ul>
        </div>
      </mat-card-content>
    </div>
  </div>

  <mat-card-actions align="end" *ngIf="loaded">
    <button mat-button (click)="cancel()">Fermer</button>
    <button mat-button [disabled]="hasErrors" (click)="validate()">Valider</button>
  </mat-card-actions>
</mat-card>
